import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconPageTextAdd: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="page-text-add"><path d="M11.25 21.25H4.75V2.75H19.25V12.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M18.25 15.25V18.25V21.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M15.25 18.25H18.25H21.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M8.75 6.75H15.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M8.75 10.75H11.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconPageTextAdd;
